import { styled } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 16 / 9;
  background-color: #f3f5f6;
  padding: 30px 30px;
  border-radius: 8px;
`;
export const Content = styled.div`
  width: 100%;
  max-width: 768px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
  align-items: center;
    & > h1 {
    color: var(--colors-text-text-primary-900, #181d27);
    text-align: center;

    /* Display sm/Regular */
    font-family: var(--Font-family-font-family-display, Ubuntu);
    font-size: var(--Font-size-display-sm, 30px);
    font-style: normal;
    font-weight: 400;
    line-height: var(--Line-height-display-sm, 38px); /* 126.667% */
  }

  & > p {
    color: var(--colors-text-text-tertiary-600, #535862);
    text-align: center;

    /* Text md/Regular */
    font-family: var(--Font-family-font-family-body, "Open Sans");
    font-size: var(--Font-size-text-md, 16px);
    font-style: normal;
    font-weight: 400;
    line-height: var(--Line-height-text-md, 24px); /* 150% */
  }
`;
